export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "charged_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Encaissé par"])},
        "column_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant"])},
        "column_commission": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commission"])},
        "column_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Période"])},
        "column_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
        "period_range": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("start")), " au ", _interpolate(_named("end"))])}
      },
      "en": {
        "charged_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charged by"])},
        "column_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount"])},
        "column_commission": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commission"])},
        "column_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Period"])},
        "column_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
        "period_range": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("start")), " to ", _interpolate(_named("end"))])}
      }
    }
  })
}
